// extracted by mini-css-extract-plugin
module.exports = {"container":"Split_container__2OgVj","body":"Split_body__1A2zv","playlistBoxes":"Split_playlistBoxes__1pQuw","bottomBar":"Split_bottomBar__1G6E1"};